import { IMessage } from '../types/messages'
import { buildParams } from '../utils/useQueryParams'

import axiosAuth from './axiosAuth'

export const getMessages = (
    controller: AbortController,
    pagination: number,
    messagesPerPage: number,
    filters: Record<
        string,
        (string | null)[] | null | undefined | boolean | number | string
    >
) => {
    const params = filters && new URLSearchParams(buildParams(filters))

    return axiosAuth.get<IMessage[]>(
        `/messages?pageNum=${pagination}&perPage=${messagesPerPage}${
            params ? `&${params}` : ''
        }`,
        {
            signal: controller.signal,
        }
    )
}

export const getMessagesFilters = (controller: AbortController) =>
    axiosAuth.get(`/messages/filters`, {
        signal: controller.signal,
    })

export const validateMessage = (id: string, message_validated: boolean) =>
    axiosAuth.put(`/messages/${id}`, {
        message_validated,
    })
